module.exports = __webpack_public_path__ + "img/loading-quote-img-1.39166b9e.png";